// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__21LYh","footer":"ModalFilter_footer__2uX0K"};